import BaseService from "./BaseService";
import {FIDO, ROOT} from "./_base";

class FidoService extends BaseService {
    async initRegisterPasskey() {
        const response = await this.getByUri(`${ROOT}/${FIDO}/init-register-passkey`);
        return response.data
    }

    async registerPasskey(data, config) {
        const response = await this.post(`${ROOT}/${FIDO}/register-passkey`, data, config);
        return response.data
    }

    async registerPasskeyLatter() {
        const response = await this.getByUri(`${ROOT}/${FIDO}/register-passkey-latter`);
        return response.data
    }

    async initReAuthenticatePasskey() {
        const response = await this.getByUri(`${ROOT}/${FIDO}/init-re-authenticate-passkey`);
        return response.data
    }

    async reAuthenticatePasskey(data, config) {
        const response = await this.post(`${ROOT}/${FIDO}/re-authenticate-passkey`, data, config);
        return response.data
    }

    async fetchAuthenticationInfo(screenName, prepareToUnMask) {
        const response = await this.get(`${ROOT}/${FIDO}/fetch-authentication-info?screenName=${screenName}&prepareToUnMask=${prepareToUnMask}`);
        return response.data
    }

    async sendAuthenticateOtp(screenName, mailType) {
        const response = await this.get(`${ROOT}/${FIDO}/send-authenticate-otp?screenName=${screenName}&mailType=${mailType}`);
        return response.data
    }

    async verifyAuthenticateOtp(data, config) {
        const response = await this.post(`${ROOT}/${FIDO}/verify-authenticate-otp`, data, config);
        return response.data
    }

    async getPasskeys() {
        const response = await this.get(`${ROOT}/${FIDO}/get-passkeys`);
        return response.data
    }

    async deletePasskey(fidoPasskeyId) {
        const response = await this.delete(`${ROOT}/${FIDO}/delete-passkey/${fidoPasskeyId}`);
        return response.data
    }
}

export default FidoService;